export default {
  "+wet4N": "Verification Code Error",
  "2QzYmY": "Cancel",
  "32AbcK": "Select Company",
  "4R5GEq": "Home",
  "9Kfib+": "Unknown Error",
  "9UZxwP": "Please enter the verification code",
  "9cYMNA": "Company Information",
  "9ljNkr": "Resend",
  "9vpYSL": "Delete Company",
  "EWMpn/": "Delete Role",
  FEb7U2: "Confirm",
  "J3BW/8": "Please enter the verification code you received via email",
  "QK/hAI": "View Permissions",
  TqDOFU: "Please do not send verification codes frequently!",
  XeiAal: "Delete",
  aiBGBs: "Delete successfully",
  azDNha: "Sent successfully",
  "e/6XZC": "Didn't receive the verification code?",
  jNxbTC: "Verification code cannot be empty",
  l1fZNE: "Cannot uncheck all boxes",
  "2MYr1m": "Login",
  "lzP/we": "Download",
  m0Qdyj: "Verification Failed",
  nJCPaY:
    "The user does not have an email address bound and cannot be verified",
  x79O39: "Are you sure to delete?",
  xxETOY: "Company data permission configuration",
  yGWx2z: "Parameter Error",
  Unvxiq: "Switch Account",
  ggvI6Z: "Select All",
  lKbhpS: "Device grayscale update time period (local time)",
  ayUfs1: "The end time cannot be earlier than the start time",
  "03eM6t": "200 items/page",
  "7/cUwn": "Device Updateable Time Period (Local Time)",
  SGDlQ6: "{total} items in total",
  "arp+TQ": "50 items/page",
  e8OyHO: "20 items/page",
  iyOrrD: "100 items/page",
  yXsHgv: "10 items/page",
  "+/R6RX": "Task Status",
  "+0SHNk": "Wi-Fi MAC Address",
  "+4lD9e": "Name",
  "+74JfZ": "Example：Device_000001_高桥店_Android",
  "+CLSks": "2. The device system type to which this naming convention applies",
  "+GQdfc": "Update Token",
  "+L9lak": "Apply alarm template",
  "+TzicH": "Merchant",
  "+gbx50": "Alarm conditions",
  "+m8vFq": "Naming Rules Details",
  "/CxA3j": "Add Sub Merchant",
  "/Qlgz9": "Upload Windows device",
  "/SqqyP": "Enter Device SN",
  "/cqdKk": "Download",
  "/sI6h+": "People",
  "0KH9Qi": "Device System Type",
  "0YYUNG": "{num} tags have been selected",
  "0iTEVO": "View Token",
  "1M03Dq": "Scheduling Template",
  "1PtjRr": "Device Name",
  "1SslIM": "Close the application",
  "1sAivX": "Ethernet MAC Address",
  "1sj5Sj": "Remove all scheduling templates applied to this device",
  "2/LdaO": "Merchant Configuration Information",
  "2nV3tA": "No Merchant selected",
  "2opnVU": "During execution",
  "2r/XUW": "Remove all scheduling templates applied to this label",
  "3HzQUc": "Export JSON",
  "3QXG/d": "Ora Version",
  "3aYG4L":
    "Remove the alarm template currently used by the device and no longer monitor and send alarms",
  "3h+3Xm": "Not Opened",
  "3jyOjJ": 'Do you want to modify the selected device to "registered"',
  "3qF993": "You cannot transfer devices that are not in the current company。",
  "4/e9qs": "Please fill In",
  "4c3uw8": "Remove from Merchant",
  "4vWL+W": "Import devices",
  "4wi+/p": "model for calligraphy or painting",
  "5+oaTO": "Image Last Update Status",
  "5Hy0Qx": "Cannot be transferred to the same Merchant",
  "5KtG4i": "Search For Enterprises",
  "5WKL9+": "Select Merchant Status",
  "5jpkHg": "Online Status",
  "5ytYaf": "Add scheduling template",
  "6+iYA0": "Serial Number",
  "60Ixlm": "Alarm Template Name",
  "6pDRb2": "Please enter a valid Password",
  "7ip592": "1. Naming Convention Name",
  "88CuCZ":
    "3. Establish a naming convention for devices registered in this Merchant (automatically fill in device names)",
  "8PESa6": "Disable",
  "8huAxo": "Add new rules",
  "8u3CYe": "Naming Convention Name",
  "8zN+hZ": "Execute application",
  "9/Vb7e": "Upload Device",
  "919TK9": "support format：xls、xlsx",
  "9UefLp": "Tag",
  "9iKk2b": "Starting number",
  "9w+ho+": "Account Number",
  "A/eXwT": "Remove all alarm templates applied to this tag",
  A5kf1W: "List of All Companies",
  ANeFu6: "Verify password",
  AyWMlZ: "Add scheduling tasks",
  B57Wbu: "No device selected",
  BBpRbn: "Remove all alarm templates used in this merchant",
  BC74I9: "Reminder information",
  BQcLxf: "Down",
  BYbqwY: "Drag the file here or click upload",
  BwXapw: "Please keep the category name within 500 characters",
  C6cGK1: "The scheduling template name cannot be empty",
  CLqPBU: "Edit",
  CPTAAj: "Natural number increment",
  D5HOUz: "Select Status",
  DADacD: "Remove all scheduling templates used in this merchant",
  DFyP1k: "Closed",
  DxGUhN: "Select all devices",
  E1GPl7: "Owner",
  EGvInA: "Device alarm list",
  EM8lAi:
    "According to the company's device, the time period that can be updated (local time)",
  EwM8Kj: "Are you sure you want to move out?",
  Ey9rBq: "Are you sure you want to delete it?",
  F2LJDJ: "Are you sure you want to remove it?",
  FBH89G: "Modified Version",
  "FaJ/jI": "No file selected for import",
  FbCeo1: "Trigger Value",
  FbsCUK: "Mobile Phone",
  "Fr1I/b": "Labeling",
  Ft60hS: "Nubis device",
  G4XFn6: "Hardware model",
  G6i1QR: "Select Address",
  G9APSK: "Edit Naming Rules",
  Gk0Mt5:
    "Are you sure to reset ({name}) the alarm device? After resetting, the alarm rules will continue to be monitored.",
  GnzEo7: "Last update time of image",
  GujK99:
    "If there are updates to the content of the alarm template in the future, it will also be synchronized with the applied devices",
  Gwj7xc: "Default",
  HN1dNJ: "All Accounts",
  HOHQFs: "Naming Convention Name cannot be empty",
  "HdxQ2/": "Merchant Associated Configuration Files and Naming Conventions",
  IqkgWZ: "keywords",
  "Iwt/8W": "Annotate",
  J9jPRL: "Replicating Success",
  JJl2M9: "Export",
  JLMIof: "Upload Android device",
  JeJAmT: "Rename",
  Jh62y5: "all device",
  Jp7u8z: "tower",
  KJHvMA: "Merchant Management",
  KlWMzW: "Active",
  LHSFrf: "Device ID",
  LNGTru: "Device scheduling failure list",
  LWSLHa: "Tips",
  Lfia0v: "Set schedule",
  "LuP+H0": "describe",
  LwhdsE: "Switch Multiple Choice",
  MmsEyp: "Register",
  MnTdIi: "Trigger times",
  OMcnk6: "Manufactuer",
  OaZpDP: "UUID",
  OcijhH: "Motherboard serial number",
  OsMncl: "Unopened",
  PaMvre: "Alarm Rule List",
  PnYplH: "Device",
  "Py/5UG": "The node being operated on no longer exists. Please operate again",
  "Q+0CDu": "Add Naming Rules",
  "Q2/NzC": "{num} devices have been selected",
  QHhMxE: "Select Character",
  QLYuf8: "All Companies",
  QV3pnn: "Status",
  QwHI8Q: "Query results：",
  R2D5Dv: "Creation Time",
  RNaGVr: "Task Failure List",
  RWBRyt: "Device distribution map construction in progress",
  RndUeh: "Expected execution time",
  S1QSWC: "Import into sub merchant",
  S57QRB: "Filter by",
  SbZhau: "The boot task requires specifying a boot device",
  SkK50H: "Please add scheduling tasks",
  SwMBFl: "Apply scheduling template",
  T3CtvK: "Classification name cannot be empty",
  TDSTTj: "Select scheduling template",
  TYAJpp: "{num} merchant have been selected",
  UA7mv6: "Last update time of Ora",
  UBbWUL: "No template selected",
  UtE0dS: "Operate",
  "Uu/nFu": "Remove all alarm templates applied to this device",
  V0RiZp: "Operation successful",
  Vd3wZV: "Whole",
  Ve9Ksw: "Transfer Merchant",
  ViVQNi: "Role",
  VqEr9u: "Apply the number of merchants",
  WYtW9Y: "Please select a version",
  WdyIyo: "Operating duration",
  WxPZOH: "Execute {num} times",
  WypzMq: "Scheduling tasks",
  Wzv7kF: "Please select a merchant",
  X2PYza: "Device Details",
  "XKj/en": "BIOS serial number",
  "XLdI1+": "Wi-Fi strength",
  XMBOec: "Remove Tag",
  XgmTAk: "Device SN",
  YeF1dY: "time zone",
  YpXN8m: "Last trigger time",
  YwEzx2: "Check the fields that need to be displayed",
  ZQ91U9: "home",
  ZUPzqr: "open",
  ZdO12B: "Apply Merchant",
  "Zvt+2g": "Warehouse",
  "a+bnYU": "Select All Across Pages",
  aBleoN: "Select alarm template",
  "aN+DgN": "Activation Time",
  akvGrq: "configure rules",
  "b+Dz+s": "List of All Merchants",
  b5l2vN: "save",
  bBz42a: "Update Status",
  "bE+h3K": "Device Status",
  bOKDVF: "Switch single choice",
  bqbDVw: "Select",
  cDZ00w: "View",
  cawvIS: "Last update time",
  dEXfrL: "Device health status interval",
  dGBGbt: "whole",
  drCsUI: "Company",
  eAgY2G: "Expand subsidiaries",
  eCCa0L: "Task Type",
  "eP/37G": "Registration Time",
  eeCxuz: "OS Type",
  evJP5c: "Naming Rules",
  f7Dpbl:
    "Download the template and follow the template prompts to improve the content",
  fz2pkM: "This node has been deleted",
  gU4eZD: "Alarm management",
  gmUXEi: "Device Characteristic Values",
  gnNjS5: "Personal device name",
  gplM71: "Daily",
  "gyh+d1": "wired network",
  h7w4pz: "No data available at the moment",
  "hD7/Lu": "display",
  "hDx3/S": "Email",
  hYN7oM: "Hide",
  hkJXyi: "Configure scheduling tasks",
  i5MLJc: "Last update time：{lastUpdate}",
  "i6kDf/":
    "Selecting a device that contains {num} Nubis Free versions will prevent device commands from being executed。",
  iKomBu: "There are currently no categories available",
  iN7Lps: "Cycle Mode",
  ich0wH: "Device SN",
  ifGp4v: "2FA",
  "j/YGZ0": "Map",
  j3QWSE:
    "The starting number for natural number increment can only be a positive integer",
  jAAXdQ: "Device Merchant",
  js3tZs: "Scheduling Template Name",
  k7dy8j: "Associate Configuration File",
  k9dozc: "execution time",
  kG2Etz: "On Line",
  khyRcw: "Please select an Excel file",
  "kr+7Iy": "Search For Merchants",
  lK6HPZ: "Please select a merchant status",
  lVgYx7: "Suspended",
  loTFGc: "Unnamed",
  m1h20o:
    "If the content of the subsequent scheduling template is updated, it will also be synchronized with the devices being applied",
  mFIXSq: "Device SN",
  "mYa6W/": "Custom Text",
  ma6S6y: "Customize Display",
  mn0ceu: "There are duplicate configuration rules, please adjust them",
  "mpeFt+": "Alarm rules",
  nGubXb: "Schedule Template Details",
  nUSeQB: "No account selected",
  nzsNwZ: "Device Health Status",
  "o+O5d1": "Please select assignment",
  o8tJYm: "Device command",
  "oFt+cN": "Network speed measurement",
  oW4Uka: "Assign",
  ojz0Ke: "See more >",
  oru5FY: "Edit scheduling template",
  "p/3Nn5": "Mobile network",
  pBPyFt: "Nubis Version",
  pK94Zd: "Import Into Merchant",
  "pV2t/S": "Basic Information",
  pXEyon: "Device Type",
  peNVzr: "Every {num} week",
  pfGGi0:
    "Remove the scheduling template currently used by the device and no longer execute it",
  pielKO: "Power on device",
  q6qKtH: "query criteria：",
  q9YGIf: "Open",
  qDba8m: "Offline Device Status",
  qUKj7E: "Copy",
  qUiH5y: "The configuration rule cannot be empty",
  "qqwM/t": "profile",
  qyh9hz: "Business Hours",
  "r0/TUu": "Submit",
  "r2dEd/": "Reset",
  rAKRwm: "Select device version",
  rDRAr0: "Operating system version",
  s7NSze: "Please enter your account password before confirming the operation",
  s9U9qn: "set alarm",
  sOIerB: "Inactive",
  sZSyGZ: "Enable",
  srEpKw: "uploading",
  srpWCM:
    "Check the fields that need to be displayed and drag them to sort them",
  t5gffJ: "Device Information",
  u3dVQz: "weekly",
  ubuOXs: "Registered",
  "uoZwj+": "Founder",
  uuRzdk: "Belonging Merchant",
  vD5wnY:
    "Checking the merchant to which you want to belong represents having permission for that merchant",
  vr5TVT: "Enter",
  wOHHSJ: "move up",
  wQAiLI: "Reset Reminder",
  "wrU/Kc": "Every {num} days",
  xISm1t: "Active",
  xUjLTE: "Search",
  xuf2rG: "All Merchants",
  yReEcE: "Select Tag",
  yb3AuG: "offline",
  ybGQQ3: "No relevant results",
  yc6ZUL: "Ora latest update status",
  ydktLD: "Separator",
  ykiGId: "User Management",
  yy7EDI: "Upload",
  zok1hp: "C slot",
  zvaxmN: "schedule management",
  zyMKgy: "Select Merchant",
  OSqnZu: "Do you want to change the selected device version to",
  "+7V2pl": "There are a total of ",
  XPFi6q: " items",
  "8iz/JA": "Merchant Code",
  Abqe2U: "Merchant Address",
  Kwqd8h: "Contacts",
  QpOtgZ: "Merchant Name",
  "d7i/AT": "Superior",
  jT6zKT: "Device ID",
  o5OLcm: "Merchant Abbreviation",
  obfTaf: "Merchant Setting",
  zarB4B: "Contact Phone",
  "pk+EdD": "Introduction to some merchant user lists",
  s1l1Jq: "Manage information of merchant",
  "+kHAfa": "Please fill In",
  "0VK6Tv": "Business Status",
  "19+woq": "Merchants Details",
  "2qrsN7": "Please Select The Merchant Address",
  "3XHWMy": "Thursday",
  "9g6s9o": "Please fill In",
  "9yRpjk": "Saturday",
  "Hv/pfB": "Tuesday",
  I37xbU: "Please Fill In",
  ITbo35: "Merchant name cannot be empty!",
  NjB2tN: "Please select business status!",
  PVmkgT: "Please fill In",
  "QsAe0/": "Save failed",
  TDuPUp: "Triggered",
  TLZPhr: "Monday",
  UZ49sl: "Responsible Person’s Phone Number",
  Vx4M25: "Merchant Code",
  "W/wIZ8": "Person In Charge",
  XmRKnc: "Notes",
  biXcnk: "Responsible Person Email",
  "fc12+X": "Friday",
  "h/j3a5": "Contract Phone",
  j6m8Si: "Contact Email",
  "jhfb/7": "Successfully Saved",
  o9lryN: "Sunday",
  sVsXUO: "Wednesday",
  xI0mPJ: "Opened",
  "J0D5h+": "Start Time",
  PrIueu: "24-Hour",
  sGYTej: "Rest",
  v04auv: "End Time",
  znuEgQ: "Add Business Hours Period",
  H5s58g: "24-Hour",
  "/8GfsH": "Thu",
  "0uRy1k": "Mon",
  M404r0: "Tue",
  Qpi3DY: "Sun",
  WYHxWn: "Wed",
  a8kQo9: "Refresh Successful",
  bFBjSK: "Fri",
  yeCGlM: "Sat",
  "1X8SYs": "latitude and longitude",
  N52KMq: "Full address",
  askOz5: "Search Address",
  stloSU: "Clean Up",
  "11uVJ/": "Receiving Object",
  "2JW1Pt": "Please choose whether to send emails simultaneously",
  "4Xdib8": "Time period cannot be empty",
  "5p8cBO": "Account Management",
  "6eB+xj": "Please Select The Designated User",
  "8usMqO": "Delete Announcement",
  "9AsSO/": "Please choose whether to send SMS at the same time",
  "9r00YD": "Announcement Management",
  Axagls: "Please select an end time",
  "EO+Nlk": "File upload in progress, please do not close the dialog box",
  F3ndvv: "Delete Failed",
  FNIJXx: "Please select scrolling playback",
  G4qgGm: "All Users",
  G5gg2V: "Announcement title is required",
  HRXYJB: "All Companies",
  JRhVym: "Business hours cannot be empty",
  Km733q: "Please choose a start time",
  L24ioQ: "Title",
  L80hmc: "Announcement title must not exceed 30 characters",
  MZ5Ei7: "The time period overlaps with the {num} th time period",
  "N/D07j": "Time periods cannot overlap",
  NGs9sO: "Return",
  "NM/lRq": "Cancel Upload",
  "OZGX3+": "Announcement List",
  "P/eul9": "No",
  QHc9Qg: "Announcement Content",
  Qpcx6F: "Announcement content is mandatory",
  RQyKsa: "Platform Announcement",
  RyXQqJ: "Upload Time",
  WtPk7v: "Simultaneously Sending Text Messages",
  YYGRyG: "Please upload the attachment",
  ZGYHyC: "The start time cannot be empty",
  aGxRt2: "Content",
  "cZ9/ZC": "Do you want to delete [{name}]?",
  cr1ymH: "Please select the sending time",
  hEI4G8: "New Announcement",
  l36W55: "Rolling Playback",
  lllhRf: "The end time cannot be empty",
  mKKd1R: "Please select the recipient",
  q9PHLT: "No announcements available at the moment",
  qD4CJe: "This is announcement management",
  tugHWJ: "Return to Announcement List",
  v4GNt7: "Designated User",
  vDCwZ9: "Upload Files",
  x34QXR: "The end time cannot be earlier than the start time",
  xXdMar: "Specify User",
  xx40g7: "Announcement Title",
  "y+WxsP": "Edit Announcement",
  yKFvYY: "Simultaneously Sending Emails",
  yOMNOj: "Correct",
  yfhtRM: "Annex",
  ygAHaf: "Sending Time",
  zftpop: "Select User",
  "/99v4N": "All Merchant",
  "5Cm9U3": "Notify",
  bzfrYI: "Announcement Settings",
  cgIBtg: "Select Parent Merchant",
  ujBeLh: "Maintenance system public notification",
  gpg5DN: "View Announcement",
  peUIwk: "Create Announcement",
  wYygRu: "Sender",
  RCjVsb: "Device ID",
  o5QBKU: "Successfully update company profile!",
  "1yM7WW": "Do you want to remove the selected device?",
  DqB8kg: "Remove Device",
  QH21BX: "Batch Register",
  TlDh4N: "Batch Remove",
  UcumBq: "Alarm notification",
  X9zJwr: "Batch Assign",
  lkP6UV: "Update Device",
  wLyMu9: "Complete the content according to the template prompts",
  FQM81K: "Change selected store status",
  WqfGVu: "Limited to 30 characters",
  hV5chR: "Please select whether to pop up",
  vD7UHb: "Pop Up",
  "0Drg5o": "I agree to the above terms",
  "7pY6K/": "Terms Content",
  CNkomH: "Edit terms",
  CoaQps: "Terms Management",
  "HHA/d7": "Terms List",
  UH1kCc: "Add",
  "VzqtN+": "Terms content is required",
  hOtsIx: "Create a new term",
  ilUpPP: "Return to Terms List",
  "j+y4w+": "Terms title is required",
  j4CmNU: "View terms",
  jJg298: "Terms Title",
  t4lrWD: "Terms title must not exceed 30 characters",
  z7A1Fc: "Create Terms",
  "OY+bYK": "Confirm, do not show it again",
  "+d1f6p": "Upload Linux device",
  UrM0bR: "Authentication Information",
  "+uAolt": "Example: Allow users to easily customize website titles, icons, and text for a personalized web experience.",
  "0UAhKu": "Example: https://www.google.com",
  "0h3ZUE": "Upload to Account Center",
  "0lEh3g": "Upload to Cloud Drive",
  "0xMj0V": "Example: Provide a new version or update device image",
  "3DMdxJ": "Edit Device Center Tab",
  "4ImW13": "Example: Merchant Management",
  "52LsQF": "Example: Account Center",
  "5BTra1": "Example: Platform",
  "61gplm": "Text Upload",
  "6sZvzw": "Replace Device Center Keywords",
  "7bKyxU": "The uploaded images will be stored in the file browser of the cloud drive. If the file is damaged or deleted, the image loading will fail.",
  "7q8OJE": "Edit Platform",
  "8TfVSD": "Edit Platform Tab",
  "8pToBN": "Example: Cloud",
  "9/8z30": "Allow users to easily customize the website title, icon, and text for a personalized web experience",
  "9C+wuW": "Example: Devices & Companies",
  "D1cAYC": "Example: Device Center",
  "FKBH20": "Example: Cloud Drive",
  "G+eQYn": "Example: Managing Your Merchant Settings",
  "G2LkOf": "Upload to Announcement Management",
  "I9uxGU": "Example: Global Service, Create Your Imagination, Provide Intelligent Experience",
  "K1Xqdl": "Example: Access Management",
  "LTVlAP": "Upload to Update Center",
  "Q1/SUP": "Example: Maintenance System Public Notice",
  "QAN35o": "Example: Device Management, Monitoring, Remote Control, etc.",
  "R8nCNR": "Upload to Devices & Companies",
  "TVuUjT": "Ora",
  "U08bUN": "Upload to Device Center",
  "Wu2nnZ": "Platform Introduction",
  "ZP1/uy": "Example: Managing Your Permissions",
  "ayjmy+": "Example: Managing Your Devices and Groups Worldwide",
  "bhXvJB": "Upload to Access Management",
  "cAIDk5": "Support Center",
  "d3b8dv": "Upload to Personalized Management",
  "dFHONh": "Nubis",
  "dWy8l5": "Example: Agent",
  "fZJ9SZ": "Example: Managing Accounts for Your Partners and Clients",
  "jAmQmn": "Example: Device Center",
  "kwx95y": "Example: Personalized Management",
  "ov96O9": "Personalized Management",
  "rM4ciX": "Example: Announcement Management",
  "uDYj3x": "Website Center",
  "uRrPru": "Upload to Merchant Management",
  "vdUVb9": "Example: Update Center",
  "xrKftB": "Icon Upload",
  "2IaM+V": "Update Center",
  "EoXhnk": "Device Center",
  "JeSd9K": "Other",
  "wzIKok": "Inherits the personalized settings of the upper-level company",
  "BQDKvZ": "Example: Agent",
  "EO9pTF": "Example: Cloud",
  "JmnNA0": "Optional Field",
  "LG70v2": "Send Order Record",
  "NZQWZL": "Formal",
  "PjtWQX": "Selected {num} Licenses",
  "Plhuph": "Search Order Number, ERP Number",
  "Rrwy85": "Creator",
  "TX6jKq": "Received",
  "U+pKlD": "Delete Order Number: {name}?",
  "Xvn+2E": "Customer Contact",
  "YII2+w": "Expiration Date",
  "YJbxtM": "Received Company",
  "ZIJmYm": "Order Management",
  "ZTs8/J": "Create Licenses",
  "a7AYs5": "Validity Period (Days)",
  "eM8o1Y": "Order Number",
  "eUSpdN": "View More",
  "er7lkB": "Amount",
  "fyjje7": "License Key",
  "gqvOsW": "Customer Contact Person", "iTiIWl": "No matching data found",
  "k1xuGk": "Search order number",
  "kPb1Wj": "ERP NO.",
  "lfUbAE": "Active",
  "mPsm6o": "Testing",
  "ouraCD": "Device Management",
  "pUL1dA": "Delete order",
  "pecEGk": "Cancel",
  "sTreBL": "Actual effective date",
  "sbThvA": "Sent company",
  "svGx//": "Please enter a valid number",
  "tMGiGt": "License type",
  "tsV2n0": "Create order",
  "twizE+": "Salesperson Email",
  "u6rHwS": "Order generation date",
  "vePxOp": "Normal",
  "wNYTXq": "Unused",
  "wawZXM": "License status",
  "xVTk70": "Loading",
  "xxFsds": "Required fields",
  "0axARa": "Invalid Date",
  "0tqhdw": "Managers and above will receive emails from [{x}] companies, totaling [{y}] companies.",
  "4DfIa5": "The selected license type must not be a beta version.",
  "4kc3eS": "On the first day of each month, the system will send an email regarding the status of licenses or devices requiring notification. The email will contain the following information.",
  "7FTqlN": "No matching licenses",
  "AfMAI0": "Device holding a license will automatically receive a new license when the current license expires.",
  "FQjcoc": "License automation rules",
  "GDWKlf": "Paired device SN",
  "Iqlkbs": "The selected license status must be unused",
  "K5iYC8": "Unused licenses that will reach their automatic activation date within the next 100 days.",
  "NBz0wZ": "Licenses currently active but not assigned to any device.",
  "URkpah": "Expired licenses",
  "UjxKxu": "Suspended",
  "VaAWfW": "Licenses with closer automatic expiration dates have higher priority",
  "Wp2PXY": "Notification Settings",
  "X2YceA": "Unused Licenses",
  "ZLqStU": "Pre-imported devices will automatically receive licenses upon registration",
  "daUauj": "License Key, Order Number, Paired Device SN",
  "eFFkgE": "License Inventory Overview",
  "eHMGvf": "Please select a License",
  "eR85km": "Device with an authorized license expiring within the next 100 days. If the license expires and no replacement license is provided, the device will be moved to a reserved state.",
  "fTfy0b": "The system will automatically apply the license in accordance with the License Automation Rules",
  "ftSBnR": "Pair License",
  "lLC16+": "License Management",
  "lQGDqR": "Device already in a reserved or suspended state.",
  "lTtEaU": "Reserved",
  "t0EXqz": "Licenses in effect",
  "vPHZLC": "Includes subsidiaries",
  "xy6tQS": "Device registered via OR Code or API will be automatically licensed",
  "zE041n": "Expiration date",
  "FQQECq": "Required",
  "ekxzlF": "Option"
};
